import React, { useContext, useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Layout from "../components/Layout";
import { AuthProvider } from "../services/authentication/auth.context";
import { useRouter } from "../utils/hooks/useRouter";
import theme from "../themes/theme";
import {
  analytics,
  createFirebaseAnalytic,
} from "../services/analytics/firebase.service";
import { initKva } from "../services/analytics/kva.service";

import RetailWiget from "../pages/platform/Platform";

function App() {
  const router = useRouter();

  const mode = "light";
  const themeData = theme(mode);

  // analytics
  useEffect(() => {
    const platform = router.query.platform || "fnb";
    if (window && !analytics) {
      createFirebaseAnalytic(platform.toString(), "");
    }
  }, [router]);
  useEffect(() => {
    initKva();
  }, []);

  return (
    <ThemeProvider theme={themeData}>
      <AuthProvider>
        <CssBaseline />
        <Layout>
          <RetailWiget />
        </Layout>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
